export const GET_LIBRARY_WORKOUTS = 'workout/GET_LIBRARY_WORKOUTS';
export const GET_LIBRARY_WORKOUTS_SUCCESS =
  'workout/GET_LIBRARY_WORKOUTS_SUCCESS';
export const GET_LIBRARY_WORKOUTS_ERROR = 'workout/GET_LIBRARY_WORKOUTS_ERROR';

export const CREATE_WORKOUT = 'workout/CREATE_WORKOUT';
export const CREATE_WORKOUT_SUCCESS = 'workout/CREATE_WORKOUT_SUCCESS';
export const CREATE_WORKOUT_ERROR = 'workout/CREATE_WORKOUT_ERROR';

export const DELETE_LIBRARY_WORKOUT = 'workout/DELETE_LIBRARY_WORKOUT';
export const DELETE_LIBRARY_WORKOUT_SUCCESS =
  'workout/DELETE_LIBRARY_WORKOUT_SUCCESS';

export const UPDATE_LIBRARY_WORKOUT = 'workout/UPDATE_LIBRARY_WORKOUT';
export const UPDATE_LIBRARY_WORKOUT_SUCCESS =
  'workout/UPDATE_LIBRARY_WORKOUT_SUCCESS';
export const UPDATE_LIBRARY_WORKOUT_ERROR =
  'workout/UPDATE_LIBRARY_WORKOUT_ERROR';

export const GET_USER_WORKOUTS = 'workout/GET_USER_WORKOUTS';
export const GET_USER_WORKOUTS_SUCCESS = 'workout/GET_USER_WORKOUTS_SUCCESS';
export const GET_USER_WORKOUTS_ERROR = 'workout/GET_USER_WORKOUTS_ERROR';
export const CLEAR_WORKOUT = 'workout/CLEAR_WORKOUT';

export const SET_IS_WORKOUT_EDIT = 'workout/SET_IS_WORKOUT_EDIT';
export const CLEAR_EDIT_WORKOUT = 'workout/CLEAR_EDIT_WORKOUT';

export const CREATE_USER_GENERATED_WORKOUT =
  'workout/CREATE_USER_GENERATED_WORKOUT';
export const CREATE_USER_GENERATED_WORKOUT_SUCCESS =
  'workout/CREATE_USER_GENERATED_WORKOUT_SUCCESS';
export const CREATE_USER_GENERATED_WORKOUT_ERROR =
  'workout/CREATE_USER_GENERATED_WORKOUT_ERROR';

export const SHARE_MY_WORKOUT = 'workout/SHARE_MY_WORKOUT';
export const SHARE_MY_WORKOUT_SUCCESS = 'workout/SHARE_MY_WORKOUT_SUCCESS';
export const SHARE_MY_WORKOUT_ERROR = 'workout/SHARE_MY_WORKOUT_ERROR';

export const RESET_WORKOUT_LOCAL_STATE = 'workout/RESET_WORKOUT_LOCAL_STATE';

// AI-generated workout staging slot. Set by AiGenerateWorkoutModal on
// a successful generation, consumed (and cleared) by createWorkoutModal's
// componentDidMount/Update so the trainer drops straight into the
// editor with the AI's draft pre-filled and ready to review.
export const SET_AI_PREFILL_WORKOUT = 'workout/SET_AI_PREFILL_WORKOUT';
export const CLEAR_AI_PREFILL_WORKOUT = 'workout/CLEAR_AI_PREFILL_WORKOUT';

// Just-saved library doc slot (see reducer's lastSavedLibraryWorkout).
// Cleared by createWorkoutModal once the tag-suggestion modal has
// consumed it — keeps a future open of the editor from re-firing the
// suggester on a doc the trainer already addressed.
export const CLEAR_LAST_SAVED_LIBRARY_WORKOUT =
  'workout/CLEAR_LAST_SAVED_LIBRARY_WORKOUT';
